import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/DarkMode.svg?component
var DarkMode_exports = /* @__PURE__ */ __exportAll({
	default: () => DarkMode_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M17.673 16.462C10.59 16.46 5.52 9.612 7.59 2.837.22 6.233-.71 16.333 5.917 21.016c5.864 4.144 14.064 1.34 16.163-5.526-1.38.64-2.884.972-4.407.972M11.996 3.484h4.866m-2.433-2.433v4.867m4.867 2.433h3.244m-1.622-1.622v3.244" }, null, -1)])]);
}
var DarkMode_default = { render: render$1 };
//#endregion
export { DarkMode_exports, DarkMode_default as default, render$1 as render };

//# sourceMappingURL=DarkMode.svg.virtual.js.map